module.exports = __webpack_public_path__ + "static/media/TTNorms-Medium.38aced5b.otf";